exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".exhibition-reg-container .sweet-modal.is-alert{width:500px;max-height:90vh}.exhibition-reg-container .sweet-modal.is-alert .sweet-content{padding:24px 32px}", ""]);

// exports
